import React, { useEffect, useState } from "react";
import Section_title from "../../../common-components/section-title/Section_title";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
} from "../../../../features/admin/customization/appsetup/Slice";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import Add from "./Add";
import Pagination_Holder from "../../../common-components/Pagination_Holder/Pagination_Holder";
import Table_search from "../../../common-components/table-search/Table_search";
import Delete_Modal from "../../../common-components/common_Modal/Delete_Modal/Delete_Modal";
import Edit from "./Edit";
const Country = () => {
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();

  const {
    country,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
    modalShow,
    setModalShow,
  } = IndexUse();

  const [add, setAdd] = useState(false);
  const [edit, setEdit] = useState(false);
  const [rdelete, setRDelete] = useState(false);
  const [showError, setShowError] = useState("");
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);

  const [id, setId] = useState("");

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const handleDelete = async (id) => {
    const success = await deleteData(id);
    setRDelete(false);
    if (success) setSuccess(true);
    else setErr(true);
  };

  const handleStatusChange = async (id) => {
    const success = await toggleStatus(id);
    await fetch();
    // if (success) setSuccess(true);
    // else setErr(true);
  };

  return (
    <section className="content_body section_box">
      <div className="top_title_sec">
        <div className="row align-items-end">
          {" "}
          <div className="col-md-12">
            <Section_title title="Transport SetUp" alltotal="" />
          </div>
        </div>
      </div>

      {/* {(id !== "" || country?.data?.data?.length === 0) && (
        <Add
          id={id}
          setId={setId}
          setSuccess={setSuccess}
          setErr={setErr}
          showError={showError}
          setShowError={setShowError}
        />
      )} */}
      <div className="table_section theme_bg">
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>S. no.</th>
                <th>Platform Percent</th>
                <th>Transport Distance</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {country?.data?.data?.length > 0 ? (
                country?.data.data?.map((val, index) => (
                  <tr key={index}>
                    <td>
                      {(country?.data?.current_page - 1) *
                        country?.data?.per_page +
                        index +
                        1}
                    </td>
                    <td>{val?.platform_percent} %</td>
                    <td>{val?.transport_distance} Km</td>

                    <td>
                      <div className="action_btns">
                        <button
                          type="button"
                          className="editbtn"
                          onClick={() => {
                            setId(val?.id);
                            setShow(true);
                          }}
                        >
                          <Link>
                            <img
                              className="icon"
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/icons/edit.png"
                              }
                            />
                          </Link>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Edit
        show={show}
        onHide={() => setShow(false)}
        id={id}
        setId={setId}
        setSuccess={setSuccess}
        setErr={setErr}
        showError={showError}
        setShowError={setShowError}
      />

      {/* <Delete_Modal
        message={"Successful"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      /> */}

      {/* <Pagination_Holder
        onPageChange={country?.data?.current_page}
        totalPages={country?.data?.total_pages}
        handlePageChange={handlePageChange}
      /> */}
    </section>
  );
};

export default Country;
